import React, { useState } from "react";
import Logo from "../../SMILe_Logo.png";
import {
  getGenerateOtpUrl,
  getVerifyOtpUrl,
  getTrackingUrl,
} from "../../config/api-config";
import { TrackingDetailsCard } from "../../components/TrackingDetails";

function generateRandomDigits(length) {
  if (length <= 0) return "";
  let result = (Math.floor(Math.random() * 9) + 1).toString();
  for (let i = 1; i < length; i++) {
    result += Math.floor(Math.random() * 10).toString();
  }
  return result;
}

function MultiInput({
  awbNumbers,
  removeAwbNumber,
  handleAddAwb,
  trackingResults,
  activeTracking,
  setActiveTrackingId,
  clearAllAwbNumbers,
}) {
  const [inputText, setInputText] = useState("");
  const [exampleNumbers] = useState(() => {
    const unique = new Set();
    while (unique.size < 3) {
      unique.add(generateRandomDigits(14));
    }
    return Array.from(unique);
  });
  const [activeTab, setActiveTab] = useState("awb");

  // Mobile/OTP flow
  const [mobile, setMobile] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpMessage, setOtpMessage] = useState("");
  const [otpError, setOtpError] = useState("");
  const [verifying, setVerifying] = useState(false);
  const [results, setResults] = useState([]);
  const [selectedTracking, setSelectedTracking] = useState(null);

  // Derived flags for layout behavior
  const currentAwbData =
    (activeTracking &&
      trackingResults?.find(
        (result) =>
          result.orderInformation?.trackingId === activeTracking ||
          result.orderInformation?.cAwbNumber === activeTracking ||
          result.statuses?.[0]?.trackingId === activeTracking ||
          result.statuses?.[0]?.cAwbNumber === activeTracking
      )) ||
    null;
  const hasAwbData = !!currentAwbData;
  const hasMobileData = !!selectedTracking;

  const submitIfReady = () => {
    const preparedValue = inputText
      .replace(/,/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (preparedValue) {
      handleAddAwb(preparedValue);
      setInputText("");
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      submitIfReady();
    }
  };

  return (
    <>
      {activeTab === "awb" ? (
        <div className={`mobile-content-wrapper ${hasAwbData ? "" : "center"}`}>
          <div className="mobile-left-panel">
            <div className="tracking-form">
              <div className="tracking-section-title">
                <p className="tracking-title">Track Your Shipments</p>
              </div>
              {/* <div className="tracking-tabs">
                <button
                  type="button"
                  className={`tracking-tab ${
                    activeTab === "awb" ? "" : "inactive"
                  }`}
                  onClick={() => setActiveTab("awb")}
                >
                  AWB Number
                </button>
                <button
                  type="button"
                  className={`tracking-tab ${
                    activeTab === "mobile" ? "" : "inactive"
                  }`}
                  onClick={() => setActiveTab("mobile")}
                >
                  Mobile Number
                </button>
              </div> */}

              <div className="tracking-input-row">
                <input
                  id="sentenceInput"
                  aria-label="AWB Number input"
                  className="tracking-input"
                  type="text"
                  value={inputText}
                  onChange={(e) => setInputText(e.target.value)}
                  onKeyDown={handleKeyDown}
                  placeholder={`Enter AWB Number`}
                />
                <button
                  type="button"
                  className="track-btn block"
                  disabled={!inputText.trim()}
                  onClick={submitIfReady}
                >
                  Track Order
                </button>
              </div>
              {/* {awbNumbers.length > 0 ? (
                <div className="tracking-chips" aria-label="Added tracking IDs">
                  {awbNumbers.map((item, index) => (
                    <span 
                      key={`${item}-${index}`} 
                      className={`chip ${activeTracking === item ? 'chip-active' : ''}`}
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        // Find and set the tracking data for this AWB
                        const trackingData = trackingResults?.find(
                          (result) => result.orderInformation?.trackingId === item
                        );
                        if (trackingData && setActiveTrackingId) {
                          setActiveTrackingId({
                            trackingId: item,
                            statuses: trackingData?.statuses || [],
                          });
                        }
                      }}
                    >
                      {item}
                      <button
                        type="button"
                        className="chip-close"
                        aria-label={`Remove ${item}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          removeAwbNumber(item);
                        }}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              ) : null} */}
              <p className="tracking-hint">
                You can track multiple IDs at once by separating them with
                commas.
                <br />
                Example: {exampleNumbers.join(", ")}
              </p>

              {awbNumbers.length > 0 && (
                <>
                  <table className="results-table">
                    <thead>
                      <tr>
                        <th>Tracking ID</th>
                        <th style={{ textAlign: "center" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[...awbNumbers]
                        .slice()
                        .reverse()
                        .map((id) => {
                          const dataObj = trackingResults?.find(
                            (r) =>
                              r?.orderInformation?.trackingId === id ||
                              r?.statuses?.[0]?.trackingId === id
                          );
                          return (
                            <tr key={`awb-row-${id}`}>
                              <td>{id}</td>
                              <td
                                style={{ paddingRight: 4, textAlign: "right" }}
                              >
                                <button
                                  type="button"
                                  className="view-btn"
                                  onClick={() => {
                                    if (setActiveTrackingId) {
                                      setActiveTrackingId({
                                        trackingId: id,
                                        statuses: dataObj?.statuses || [],
                                      });
                                    }
                                  }}
                                >
                                  View
                                </button>
                                <button
                                  type="button"
                                  className="clear-btn"
                                  style={{ marginLeft: 4 }}
                                  onClick={() => removeAwbNumber(id)}
                                >
                                  Clear
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  </table>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 8,
                    }}
                  >
                    <button
                      type="button"
                      className="clear-btn"
                      onClick={clearAllAwbNumbers}
                    >
                      Clear All
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>

          {hasAwbData && (
            <div className="mobile-right-panel">
              <TrackingDetailsCard trackingData={currentAwbData} />
            </div>
          )}
        </div>
      ) : (
        <div
          className={`mobile-content-wrapper ${hasMobileData ? "" : "center"}`}
        >
          <div className="mobile-left-panel">
            <div className="tracking-form">
              <div className="tracking-section-title">
                <p className="tracking-title">Track Your Shipments</p>
              </div>
              {/* <div className="tracking-tabs">
                <button
                  type="button"
                  className={`tracking-tab ${
                    activeTab === "awb" ? "" : "inactive"
                  }`}
                  onClick={() => setActiveTab("awb")}
                >
                  AWB Number
                </button>
                <button
                  type="button"
                  className={`tracking-tab ${
                    activeTab === "mobile" ? "" : "inactive"
                  }`}
                  onClick={() => setActiveTab("mobile")}
                >
                  Mobile Number
                </button>
              </div> */}

              <div className="tracking-input-row">
                <input
                  className="tracking-input"
                  type="tel"
                  inputMode="numeric"
                  maxLength={10}
                  placeholder="Enter Mobile Number"
                  value={mobile}
                  onChange={(e) => {
                    const onlyDigits = e.target.value.replace(/\D/g, "");
                    const next = onlyDigits.slice(0, 10);
                    setMobile(next);
                    // If the user edits the mobile number, reset OTP state so the
                    // "Generate OTP" button is shown again and stale OTP is cleared.
                    setOtpSent(false);
                    setOtp("");
                    setOtpMessage("");
                    setOtpError("");
                  }}
                />
                {!otpSent && (
                  <button
                    type="button"
                    className="track-btn"
                    disabled={mobile.length !== 10}
                    onClick={async () => {
                      setOtpError("");
                      setOtpMessage("");
                      try {
                        const resp = await fetch(getGenerateOtpUrl(mobile), {
                          method: "POST",
                        });
                        const data = await resp.json().catch(() => ({}));
                        if (resp.ok && data?.status === "success") {
                          setOtpSent(true);
                          setOtpMessage(data?.message || "OTP sent.");
                        } else {
                          setOtpError(data?.message || "Failed to send OTP.");
                        }
                      } catch (err) {
                        setOtpError("Network error. Please try again.");
                      }
                    }}
                  >
                    Generate OTP
                  </button>
                )}
              </div>

              {otpMessage && (
                <p className="tracking-hint hint-success">{otpMessage}</p>
              )}

              {otpSent && (
                <div className="tracking-input-row">
                  <input
                    className="tracking-input"
                    type="tel"
                    inputMode="numeric"
                    placeholder="Enter 6-digit OTP"
                    value={otp}
                    onChange={(e) => {
                      const onlyDigits = e.target.value.replace(/\D/g, "");
                      setOtp(onlyDigits.slice(0, 6));
                    }}
                    maxLength={6}
                  />
                  <button
                    type="button"
                    className="track-btn"
                    disabled={otp.length !== 6 || verifying}
                    onClick={async () => {
                      setVerifying(true);
                      setOtpError("");
                      setOtpMessage("");
                      setResults([]);
                      try {
                        const resp = await fetch(getVerifyOtpUrl(), {
                          method: "POST",
                          headers: { "content-type": "application/json" },
                          body: JSON.stringify({
                            mobileNumber: mobile,
                            otp_number: otp,
                          }),
                        });
                        const data = await resp.json().catch(() => ({}));
                        if (resp.ok && data?.status === "success") {
                          setResults(
                            Array.isArray(data?.data) ? data.data : []
                          );
                          setOtpMessage(data?.message || "OTP verified.");
                        } else {
                          setOtpError(data?.message || "Invalid OTP.");
                        }
                      } catch (err) {
                        setOtpError("Network error. Please try again.");
                      } finally {
                        setVerifying(false);
                      }
                    }}
                  >
                    Verify OTP
                  </button>
                </div>
              )}

              {otpError && (
                <p className="tracking-hint hint-error">{otpError}</p>
              )}

              {results.length > 0 && (
                <table className="results-table">
                  <thead>
                    <tr>
                      <th>Tracking ID</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {results.map((row, idx) => (
                      <tr key={`${row.trackingId}-${idx}`}>
                        <td>{row.trackingId}</td>
                        <td>
                          <button
                            type="button"
                            className="view-btn"
                            onClick={async () => {
                              try {
                                const resp = await fetch(
                                  getTrackingUrl(row.trackingId)
                                );
                                const data = await resp.json();
                                if (
                                  data?.statuses &&
                                  data.statuses.length > 0
                                ) {
                                  setSelectedTracking(data);
                                }
                              } catch (err) {
                                console.error(
                                  "Error fetching tracking data:",
                                  err
                                );
                              }
                            }}
                          >
                            View
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          {hasMobileData && (
            <div className="mobile-right-panel">
              <TrackingDetailsCard trackingData={selectedTracking} />
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default MultiInput;
